import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-border/40 bg-background" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="font-heading text-3xl font-light tracking-widest">
              NYMPHEA
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-sm leading-relaxed">
              De l'idée à la peau : l'art prend vie. Tatouages personnalisés dans un univers doux et artistique.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://instagram.com/nymphea.ttt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.tiktok.com/@nymphea.ttt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                data-testid="footer-tiktok"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/portfolio" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/flashs" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Flashs
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/demande-projet" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Demande de projet
                </Link>
              </li>
              <li>
                <Link to="/rendez-vous" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Prendre rendez-vous
                </Link>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Informations
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="text-sm text-foreground hover:text-muted-foreground transition-colors">
                  Confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-border/40 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} NYMPHEA. Tous droits réservés.
          </p>
          <p className="text-xs text-muted-foreground">
            Atelier La Peauésie — Les Sables-d'Olonne
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
